import React from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import BackArrow from "features/icons/BackArrow";
import AppHeading1 from "./AppHeading1";
import AppSimpleText from "./AppSimpleText";
import PageBreadcrumbs from "components/PageBreadCrumbs";
import { useMatchMediaDimensions } from "hooks/useWindowDimensions";

const AppContainer = ({
  title = "",
  subTitle = "",
  loading = false,
  children,
  showBackButton = false,
  backButtonText = "",
  backButtonPath = "",
  wrapperProps,
  containerProps,
  footer,
  onBack,
  showBreadcrumbs = false,
}) => {
  const { t } = useTranslation();
  const router = useHistory();
  const isMobile = useMatchMediaDimensions(768);
  const { pageBreadCrumb } = useSelector((state) => state.LanguageSlice);
  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
    } else {
      if (backButtonPath) {
        router.push(backButtonPath);
      } else {
        router.goBack();
      }
    }
  };

  return (
    <div
      {...wrapperProps}
      className={`flex w-full flex-col md:overflow-hidden relative rounded-3xl bg-white py-5 ps-5 ${
        wrapperProps?.className || ""
      }`}
      style={{
        maxWidth: "100%",
        ...(!isMobile ? { height: "calc(100vh - 165px)" } : {}),
        ...containerProps?.style,
      }}
    >
      <Spin
        spinning={loading}
        wrapperClassName="app-container-spin-wrap h-full min-h-0 min-w-0 max-w-full w-full"
      >
        {showBackButton && (
          <div className="mb-0 flex-shrink-0">
            <div
              className="cursor-pointer inline-flex items-center"
              onClick={handleBack}
            >
              <span className="align-middle">
                <BackArrow onClick={handleBack} />
              </span>
              {backButtonText && (
                <span className="align-middle px-2 text-gray-800">
                  {backButtonText}
                </span>
              )}
            </div>
          </div>
        )}
        {(title || subTitle || showBreadcrumbs) && (
          <div className="z-10 flex-shrink-0 bg-white">
            {title && <AppHeading1>{t(title)}</AppHeading1>}
            {subTitle && <AppSimpleText>{t(subTitle)}</AppSimpleText>}
            {showBreadcrumbs && (
              <PageBreadcrumbs breadcrumbs={pageBreadCrumb} />
            )}
          </div>
        )}
        <br />
        <div
          {...containerProps}
          className={`flex min-h-0 min-w-0 max-w-full flex-1 flex-col md:overflow-y-auto pe-5 ${
            containerProps?.className || ""
          }`}
        >
          {children}
        </div>

        {footer ? (
          <div className="z-10 mt-0 flex-shrink-0 border-t border-gray-100 bg-white pt-4 pe-5">
            {footer}
          </div>
        ) : null}
      </Spin>
    </div>
  );
};

export default AppContainer;
